import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-3">专题索引</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">按分类快速定位您感兴趣的内容频道</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexItems.map((item, idx) => (
            <a
              key={idx}
              href="#media"
              className="flex items-center gap-4 p-4 bg-background-50 rounded-lg border border-background-200/60 hover:border-primary-300/60 transition-all cursor-pointer group"
            >
              <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div className="min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="text-sm font-semibold text-foreground-800 truncate">{item.title}</h3>
                  <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-accent-100 text-accent-600 whitespace-nowrap flex-shrink-0">
                    {item.tag}
                  </span>
                </div>
                <p className="text-xs text-foreground-400 mt-0.5">{item.count}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}